<template>
  <div class="ruleBox">
    <div class="tip">
      <p class="title">活动时间</p>
      <div class="content">
        <p class="text">2022/7/15 00:00 至 2022/8/30 23:59</p>
      </div>
    </div>
    <div class="tip rule">
      <p class="title">活动规则</p>
      <div class="content">
        <ul>
          <li v-for="(item, index) in ruleList" :key="index" class="text">
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "活动规则",
    };
  },
  data() {
    return {
      ruleList: [
        "1.登录即送价值3840元满减优惠券，优惠券仅限购买单课课程与会员卡年卡使用，优惠券有效期为2022年7月15日 00:00-2022年8月30日 23:59。",
        "2.平台推出精选套餐包，精选套餐包不参与满减券抵扣活动。",
        "3.全场所有单课课程打8折，折扣活动可与满减优惠券叠加使用。",
        "4.如有任何疑问，可联系客服：18167176677(微信同号)咨询。 ",
        "5.在法律允许的范围内，本活动最终解释权归浙江艺高文化创意有限公司所有。",
        "6.本活动与苹果公司无关",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.ruleBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  overflow: auto;
  color: rgba(45, 45, 45, 1);
  padding-bottom: 50px;
  .tip {
    margin: 24px 16px 0;
    .title {
      font-size: 16px;
      line-height: 22px;
      font-weight: 600;
    }
    .content {
      margin-top: 16px;
    }
    .text {
      font-size: 14px;
      line-height: 24px;
      font-weight: 300;
    }
  }
}
</style>